<template>
  <v-expansion-panels v-model="searchOpen">
    <v-expansion-panel>
      <v-expansion-panel-header>Filter</v-expansion-panel-header>

      <v-divider />

      <v-row
        no-gutters
        align="center"
        v-show="
          (search.headline || search.industry || search.location) &&
            searchOpen !== 0"
      >
        <v-col>
          <div class="px-6 caption mb-4 pt-3">
            <span
              v-show="search.headline"
            >Title "<strong>{{ search.headline }}</strong>"&nbsp;<br></span>
            <span
              v-show="search.industry"
            >Industry "<strong>{{ search.industry }}</strong>"&nbsp;<br></span>
            <span
              v-show="search.location"
            >Location "<strong>{{ search.location }}</strong>"&nbsp;<br></span>
          </div>
        </v-col>

        <v-col
          cols="auto"
          class="mr-4 py-1"
        >
          <v-btn
            small
            fab
            icon
            @click="clearSearch"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expansion-panel-content>
        <v-text-field
          v-model="search.headline"
          append-icon="search"
          flat
          outlined
          hide-details
          label="Title"
          class="mt-5"
          solo
          background-color="white"
          clearable
          @click:clear="clearSearch"
          @keyup="handleSearch('title')"
        />

        <v-select
          v-model="search.industry"
          :items="searchLists.industries"
          label="Industry"
          class="my-3"
          hide-details
          clearable
          solo
          @click:clear="clearSearch"
          @change="handleSearch('industry')"
        />

        <v-select
          v-model="search.location"
          :items="searchLists.locations"
          label="Location"
          class="mb-3"
          hide-details
          clearable
          solo
          @click:clear="clearSearch"
          @change="handleSearch('location')"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { debounce, IDebouncedFunction } from 'debounce'

import Industries from '@/assets/profile/industries'
import Location from '@/assets/fields/location'
import { IOppSearchField } from '@/types/filters'
import { trackSearchFieldFill, ISearchField } from '@/segmentAnalytics/opportunities'

@Component
export default class SearchField extends Vue {
  @Prop({ required: true }) search: IOppSearchField
  @Prop({ required: true }) label: string

  searchOpen: string|null = null
  searchLists: any = {
    industries: Industries,
    locations: Location
  }

  // lifecycle hooks
  created () {
    this.emitSearchingDebounced = debounce((inputName: ISearchField) => {
      trackSearchFieldFill(inputName)
      this.$emit('searching', this.search)
    }, 600)
  }

  // methods
  private emitSearchingDebounced: IDebouncedFunction

  private clearSearch () {
    this.$emit('clearSearch')
  }

  private handleSearch (inputName: ISearchField) {
    this.emitSearchingDebounced(inputName)
  }
}
</script>
